import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { concat, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DEFAULT_EDITOR_TOOLBAR_CONFIG, ToastService } from 'src/app/core';
import { ActiveDirectoryService } from 'src/app/core/active-directory.service';
import { AdUser, EmailApi, EmailAttachments, ExitApi, ExitEmailAttachments } from 'src/app/core/api.gen';
import { AttachmentUploadService } from 'src/app/core/attachment-upload.service';
import { DocumentUploadService } from 'src/app/core/document-upload.service';
import { LoaderService } from 'src/app/core/loader.service';
import { OpenFilePreviewService } from 'src/app/core/open-file-preview.service';
import { nullSafe } from 'src/app/utils';
import { isNullOrUndefined } from '../../../app/core/utils';
import { CommonService } from '../../core/common.service';
import { DocumentService } from '../../core/document.service';
import { ModuleTypes } from '../module-types';
import { allowedMineTypes } from './email-toolbar-configs';
import { ControlView, GeneralMail } from './general-mail-model';

@Component({
  selector: 'eos-configurable-mail',
  templateUrl: './configurable-mail.component.html',
  styleUrls: ['./configurable-mail.component.css']
})
export class ConfigurableMailComponent implements OnInit, OnDestroy {

  @Input() showMultipleTemps: boolean = false;
  @Input() public header = 'Header';
  @Input() public showFileUploader = false;
  @Input() public submit: (mail) => void;
  @Input() public saveAsDraft: (mail) => Observable<any>;
  @Input() public fileUpload: (file: any) => Observable<any>;
  @Input() public loadSelectedTemplate: (mail) => void;
  @Input() public loadUploadedFiles: () => Observable<any>;
  @Input() public deleteFile: (details) => Observable<any>;
  @Input() public templateAttchaments: () => Observable<any>;

  @Input() showSaveDraft = false;
  @Input() showAttachments = false;
  @Input() email: any;
  @Input() candidate: any;
  @Input() isShareDocs: boolean = false;
  @Input() ismultipleShareDocs: boolean = false;
  @Input() headerControlAccess: ControlView = ControlView.hidden;
  @Input() moduleType = ModuleTypes.Exit;
  @Input() mulShareDocs = [];
  @Input() isDocShare = false; 



  fileUploadSubscription: Subscription;
  fileGetterSubscription: Subscription;
  deleteFileSub: Subscription;
  saveAsDraftSub: Subscription;
  templateSubscription: Subscription;



  onDestroy$ = new Subject<void>();
  tosearchInput$ = new Subject<string>();
  ccsearchInput$ = new Subject<string>();
  toAdUsers: any = [];
  ccAdUsers: any = [];
  toShowLoader;
  ccShowLoader;
  tos = [];
  ccs = [];

  emailpattern = /^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
  editorForm: UntypedFormGroup;
  results: GeneralMail = new GeneralMail();
  isDisabled = false;
  activitytemplateId: number;
  uploadedFiles = [];

  candidateDocs = [];
  disableAttach = false;
  selectedCandiFiles = [];

  toolbarConfig = { ...DEFAULT_EDITOR_TOOLBAR_CONFIG };
  // upload
  docnamePattern = "^[a-zA-Z0-9 ]*$";
  newAttachments: EmailAttachments[] = [];
  @ViewChild('fileField') element: ElementRef;
  @ViewChild('fileControl') fileEle: ElementRef;
  @ViewChild('f', { static: true }) form: NgForm;
  
  immigrationCandidateActivityId?: number = 0;
  fileDetails: any = { fileName: '' };
  selectedDocument: File;
  disableUpload = false;

  showUpload = true;
  allowedMineTypes = allowedMineTypes;

  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;
  constructor(private common: CommonService,
    public modal: NgbActiveModal,
    private toast: ToastService,
    private ad: ActiveDirectoryService,
    private openFilePreviewService: OpenFilePreviewService,
    private documentUploadService: DocumentUploadService,
    private attachmentUploadService: AttachmentUploadService,
    private loader: LoaderService,
    private exitApi: ExitApi,
    private documentService: DocumentService) { }

  setModel() {
    this.results.attachments = this.email.attachments;
    this.results.bcc = this.email.bcc;
    this.results.cc = this.email.cc;
    this.results.content = this.email.content;
    this.results.fromAddresses = this.email.fromAddresses;
    this.results.isMissingValues = this.email.isMissingValues;
    this.results.subject = this.email.subject;
    this.results.toAddresses = this.email.toAddresses;
  }
  ngOnInit(): void {
    this.setModel();
    this.form.valueChanges.subscribe(x =>
      this.patternValid(this.form)
    );
    if (this.showFileUploader) {
      this.loadCustomUploadedFiles();
      // this.getNewlyUploadedAttachmentDetails();

    }
    if(this.showAttachments && !this.isDocShare){
      this.getNewlyUploadedAttachmentDetails();
    }
    this.editorForm = new UntypedFormGroup({
      email: new UntypedFormControl(null)
    });
    this.editorForm.patchValue({ email: this.results.content });
    this.tos = this.addAddresses(this.results.toAddresses);
    this.ccs = this.addAddresses(this.results.cc);
    this.toAdUsers = this.getAdUsers(true, this.tosearchInput$);
    this.ccAdUsers = this.getAdUsers(false, this.ccsearchInput$);
    this.uploadedFiles = this.email.uploadedFiles;
    if (this.ismultipleShareDocs) {
      this.candidateDocs = this.documentService.updateCandidateDocs(this.mulShareDocs, false, this.mulShareDocs);
      this.isDisabled = true;
    }
  }

  loadCustomUploadedFiles() {
    this.fileGetterSubscription = this.loadUploadedFiles().subscribe(resp => {
      this.uploadedFiles = resp;
      if (!this.isShareDocs && !this.ismultipleShareDocs) {
        this.loadCandidateDocs();
      }
    })
  }

  getNewlyUploadedAttachmentDetails() {
    this.templateSubscription = this.templateAttchaments().subscribe(resp => {
      this.newAttachments = resp;
    });
  }


  loadCandidateDocs() {
    this.exitApi.getAllDocumentDetails(this.common.exitProfileId)
      .subscribe(resp => {
        this.candidateDocs = this.documentService.updateCandidateDocs(this.uploadedFiles, true, this.documentService.changeDocumentName(resp, this.moduleType));
      });
  }

  attachCandidateFilesToMail() {
    if (this.selectedCandiFiles.length > 0) {
      this.exitApi.attachCandidateDocsToMail(this.candidateEmailAttachments())
        .subscribe(resp => {
          this.uploadedFiles.push(...resp);
          this.toast.success("File uploaded successfully!");
          this.candidateDocs = this.documentService.updateCandidateDocs(this.selectedCandiFiles, true, this.candidateDocs);
        }, () => {
          this.toast.error("Something went wrong, couldn't attach files. Please try again later");
        });
    }
  }

  ShareDocFn(val) {
    this.selectedCandiFiles = val;
    if (this.ismultipleShareDocs) {
      this.selectedCandiFiles.forEach(item => {
        this.uploadedFiles.push(item);
      });
      this.isDisabled = false;
      this.toast.success("File uploaded successfully!");
      this.candidateDocs = this.documentService.updateCandidateDocs(this.selectedCandiFiles, true, this.candidateDocs);
    } else {
      this.attachCandidateFilesToMail();
    }
  }
  candidateEmailAttachments() {
    let files = [];
    this.selectedCandiFiles.forEach(item => {
      const attachment = new ExitEmailAttachments({
        fileName: item.fileName,
        fileGuiId: item.fileGuiId,
        exitRequestActivityId: this.email.exitRequestActivityId,
        emailTemplateId: this.email.activityTemplateId
      });
      files.push(attachment);
    });
    return files;
  }

  adUser() {
    return new AdUser({
      displayName: `${this.candidate.firstName} ${this.candidate.lastName}`,
      userPrincipalName: this.candidate.emailID,
    });
  }

  patternValid(f: NgForm) {
    const ccForm = f.form.get("cc");
    const addressForm = f.form.get("toAddresses");

    if (!isNullOrUndefined(addressForm)) {
      addressForm.value.forEach(item => {
        if (!item.match(this.emailpattern) && !isNullOrUndefined(addressForm)) {
          addressForm.setErrors({ incorrect: true });
        }
      });
    }

    if (!isNullOrUndefined(ccForm)) {
      if (ccForm.value.length === 0) {
        ccForm.setErrors(null);
        return;
      }
      ccForm.value.forEach(item => {
        const valid = item.match(this.emailpattern);
        if (!item.match(this.emailpattern) && !isNullOrUndefined(ccForm)) {
          ccForm.setErrors({ incorrect: true });
        }
      });
    }
  }

  addAddresses(email: string) {
    const emailArray = [];
    if (email && email.length > 0) {
      email.split(';').forEach(item => {
        // if (item.match(this.emailpattern)) {
        emailArray.push(item);
        // }
      });
    }

    return emailArray;
  }

  getAdUsers(setToLoader: boolean, subject) {
    let obs = concat(
      of([]),
      subject.pipe(
        takeUntil(this.onDestroy$),
        startWith(''),
        filter((v: string) => v !== null && v.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.setAdloader(setToLoader);
        }),
        switchMap((term: string) => this.ad.getAdUsers(term).pipe(
          catchError(() => of([])),
          tap((users) => {
            this.toShowLoader = false;
            this.ccShowLoader = false;
            if (nullSafe<boolean>(() => this.candidate.firstName.toLowerCase().startsWith(term.toLowerCase()), false)
              || nullSafe<boolean>(() => this.candidate.emailID.toLowerCase().startsWith(term.toLowerCase()), false)) {
              users.push(this.adUser());
            }
          })
        ))
      ));
    return obs;
  }

  get headerVisibilty(): boolean {
    switch (this.headerControlAccess) {
      case ControlView.hidden:
        return false;
      default:
        return true;
    }
  }

  get headerAccessiblity() {
    switch (this.headerControlAccess) {
      case ControlView.disabled:
        return false;
      default:
        return true;
    }
  }
  setAdloader(isToLoader) {
    if (isToLoader) {
      this.toShowLoader = true;
      this.ccShowLoader = false;
    } else {
      this.toShowLoader = false;
      this.ccShowLoader = true;
    }
  }

  getUploadedAttachmentDetails(profileId: number, activityId: number, emailTemplateId: number) {
  }

  delete(fileDetails) {
    this.selectedCandiFiles = [];
    this.selectedCandiFiles.push(fileDetails);
    if (!this.ismultipleShareDocs) {
      this.deleteFileSub = this.deleteFile(fileDetails).subscribe((resp) => {
        this.toast.success("Attachment deleted!");
        this.candidateDocs = this.documentService.updateCandidateDocs(this.selectedCandiFiles, false, this.candidateDocs);
        this.loadCustomUploadedFiles();
      });
    } else {
      for (var i = 0; i < this.uploadedFiles.length; i++) {
        if (this.uploadedFiles[i].fileGuiId === fileDetails.fileGuiId) {
          this.uploadedFiles.splice(i, 1);
          this.candidateDocs = this.documentService.updateCandidateDocs(this.selectedCandiFiles, false, this.candidateDocs);
          break;
        }
      }
      if (this.uploadedFiles.length == 0) {
        this.isDisabled = true;
      }
    }
  }

  downloadAttachment(details) {
    this.attachmentUploadService.downloadAttachment(details);
  }

  

  sendMail(f: NgForm) {
    if (f.invalid) {
      return;
    }
    this.mapBackToEmail();
    this.submit(this.email);
    if (!this.isShareDocs && !this.ismultipleShareDocs) {
      this.modal.dismiss();
    }
  }

  mapBackToEmail() {
    this.email.toAddresses = this.tos.join(';');
    this.email.cc = this.ccs.join(';');
    this.email.attachments = this.email.attachments;
    this.email.content = this.results.content;
    this.email.fromAddresses = this.results.fromAddresses;
    this.email.isMissingValues = this.results.isMissingValues;
    this.email.subject = this.results.subject;
    this.email.customAttachments = this.newAttachments;
    this.email.candidateDocuments = this.uploadedFiles;
  }

  removeAttachment(id) {
    if (this.newAttachments.includes(id)) {
      this.newAttachments.splice(this.newAttachments.indexOf(id), 1);
    }
    else {
      this.results.attachments.splice(id, 1);
    }
 
  }

  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }
    return false;
  }

  browseFile() {
    this.fileEle.nativeElement.click();
  }

  get fileBrowserAllowedTypes() {
    return this.allowedMineTypes.join(',');
  }

  fileSelected(files: FileList) {
    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {

      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB
       and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);

      this.fileEle.nativeElement.value = null;
      return;
    }
    if (this.allowedMineTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }

    this.fileDetails.fileName = this.selectedDocument.name;
  }

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }


  uploadDoc(f: NgForm) {

    if (f.invalid) {
      return;
    }

    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()}
       KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }
    // if (this.allFiles.some((item) => (item.fileName === this.fileDetails.fileName) && (item.id !== this.fileDetails.id))) {
    if (this.uploadedFiles.some((item) => (item.fileName === this.selectedDocument.name) && (item.id !== this.fileDetails.id))) {
      this.toast.error("Attachment Name should be unique");
      return;
    }
    this.upload(f);
  }

  upload(f: NgForm) {
    f.form.disable();
    this.disableUpload = true;
    this.isDisabled = true;
    this.fileUploadSubscription = this.fileUpload(this.selectedDocument).pipe(finalize(() => {
      this.selectedDocument = null;
      this.fileEle.nativeElement.value = null;
      f.form.enable();
      this.disableUpload = false;
      this.isDisabled = false;
    }))
      .subscribe(resp => {
        this.element.nativeElement.value = "";
        if (this.selectedDocument) {
          this.toast.success("File uploaded successfully!");
        }
        this.loadCustomUploadedFiles();
      }, error => {
        this.toast.error("Something went wrong!");
      });
  }

  downloadFile(fileName: string) {
    this.documentUploadService.downloadDocumentFile(fileName);
  }

  previewFile(fileName: string) {
    this.openFilePreviewService.previewAttachmentFile(fileName);
  }

  saveMailAsDraft(f: NgForm) {
    f.form.disable();
    this.mapBackToEmail();
    this.saveAsDraftSub = this.saveAsDraft(this.email).pipe(finalize(() => {
      this.loader.clear();
      f.form.enable();
    })).subscribe(resp => {
      this.email.emailHistoryId = resp.data;
      this.toast.success("Mail saved as draft!");
    });;
  }

  ngOnDestroy() {
    if (this.fileGetterSubscription) {
      this.fileGetterSubscription.unsubscribe();
    }
    if (this.fileUploadSubscription) {
      this.fileUploadSubscription.unsubscribe();
    }
    if (this.deleteFileSub) {
      this.deleteFileSub.unsubscribe();
    }
    if (this.saveAsDraftSub) {
      this.saveAsDraftSub.unsubscribe();
    }
    if (this.templateSubscription) {
      this.templateSubscription.unsubscribe();
    }

  }

}
